import React, { createContext, useContext, useState } from 'react';

const DRAWER_STATE_KEY = 'frontdoor_drawer_collapsed';

export const DrawerContext = createContext();

export function useDrawer() {
    return useContext(DrawerContext);
}

// We do save in localStorage whether the drawer is collapsed or not so when user come back it's preserved
export function DrawerProvider(props) {
    const [isCollapsed, setIsCollapsed] = useState(() => {
        const stored = localStorage.getItem(DRAWER_STATE_KEY);
        return stored ? JSON.parse(stored) : false;
    });

    const toggleDrawer = () => {
        setIsCollapsed((prev) => {
            const newState = !prev;
            localStorage.setItem(DRAWER_STATE_KEY, JSON.stringify(newState));
            return newState;
        });
    };

    return (
        <DrawerContext.Provider value={{ isCollapsed, toggleDrawer }}>
            {props.children}
        </DrawerContext.Provider>
    );
}
